import React, { useEffect } from 'react';
import styled from 'styled-components';
import { Card, CardDescription, CardTitle } from '@wfp-common/components/card/Card';

import { authLogin } from '../apiClient';
import { Profile } from '../icons/Profile';
import { windowStorage, WindowStorageToken } from '../windowStorage';

const LogoutSuccessPage: React.FC = () => {
    useEffect(() => {
        windowStorage.removeItem(WindowStorageToken.managerApiToken);
    }, []);

    const handleLogin = () => {
        const returnUrl = sessionStorage.getItem('returnUrl');
        const options = returnUrl ? { returnUrl } : undefined;
        authLogin(options).then((r) => {
            if (r.login_url) {
                window.location.replace(r.login_url);
            }
        });
    };

    return (
        <PageWrapper>
            <Card>
                <Icon>
                    <Profile color={'#4caf50'} />
                </Icon>
                <CardTitle>Successfully Logged Out</CardTitle>
                <CardDescription>
                    You have been successfully logged out of the application. Thank you for using our services.
                </CardDescription>
                <button className="wfp-btn--primary" onClick={handleLogin} type={'button'}>
                    Log In Again
                </button>
            </Card>
        </PageWrapper>
    );
};

const PageWrapper = styled.div`
    display: flex;
    justify-content: center;
    align-items: center;
`;

const Icon = styled.div`
    margin-bottom: 24px;
`;

export default LogoutSuccessPage;
